export default {
      id: "oc-res-explorer-usage",
      viewBox: "0 0 1301 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-explorer",
      toString: function () {
        return this.url;
      }
    }